import React, { useState } from "react";
import axios from "axios";

const Razorpy = () => {
  const [amount, setAmount] = useState(100);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (amount === "") {
      alert("please enter amount");
    } else {
      var options = {
        key: "rzp_test_uObickv1iAXy2d",
        // key_secret: "iExGzM7nCvTIo41Rk4iV9kye",
        amount: amount * 100,
        currency: "INR",
        name: "Savart",
        description: "for testing purpose",
        handler: function (response) {
          alert(response.razorpay_payment_id);
        },
        prefill: {
          name: "",
          email: "",
          contact: "",
        },
        notes: {
          address: "Svobodha Infinity Investment Advisors Pvt. Ltd.,",
        },
        theme: {
          // color: "#3399cc",
          color: "#170e9c",
        },
      };
      var pay = new window.Razorpay(options);
      pay.open();
    }
  };

  return (
    <div>
      <div>
        <h2>Please click below to proceed to the Payment Gateway</h2>
      </div>
      <button onClick={handleSubmit}>Request to Pay</button>
    </div>
  );
};

export default Razorpy;
